const SIZE = 34 // Size of Control Button in Live Sessions;

export default SIZE;